import gql from "graphql-tag";

export const UPADTE_DEAL = gql`
  mutation update_deals_by_pk(
    $id: uuid!
    $name: String!
    $type: deal_type_enum
    $condition: String
    $description: String
    $image_path: String
    $image_url: String
    $expire_date_time: timestamp
  ) {
    update_deals_by_pk(
      pk_columns: { id: $id }
      _set: {
        name: $name
        type: $type
        condition: $condition
        description: $description
        image_path: $image_path
        image_url: $image_url
        expire_date_time: $expire_date_time
      }
    ) {
      id
    }
  }
`;
